import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getCookie } from '../../../utils/getCookies';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-offer-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offer-details.component.html',
  styleUrl: './offer-details.component.scss'
})
export class OfferDetailsComponent {

    offerId: any;
    jobOffer: any;
    constructor(private route: ActivatedRoute, private http: HttpClient) {
        this.route.queryParams.subscribe((params: any) => {
            this.offerId = params['offer_id'];
        });
    }

    ngOnInit() {
        this.loadJobOffer(this.offerId);
    }
    
    loadJobOffer(offerId: number) {
        const accessToken = getCookie('access_token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${accessToken}`
        });

        this.http.post(`${environment.url}/api/company/jobOfferbyId`, { offer_id: offerId }, { headers }).subscribe((data: any) => {
            this.jobOffer = data["joboffer"];
        });
    }
      
    
}
